// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2026 Vic Zhu <viczhu2014@gmail.com>

import RestaurantIcon from '@mui/icons-material/Restaurant'
import FoodCreate from './FoodCreate'
import FoodEdit from './FoodEdit'
import FoodList from './FoodList'

export default {
  list: FoodList,
  edit: FoodEdit,
  create: FoodCreate,
  icon: RestaurantIcon,
  recordRepresentation: 'displayName',
}
